import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import api from '../config/axios';
import ProfileAndCommentComponent from '../components/AppHome/ProfileAndCommentComponent';
import PostCommentAndLikesShareComponent from '../components/AppHome/PostCommentAndLikesShareComponent';

function PostView() {
  const { postId } = useParams();
  const [post, setPost] = useState(null);
  const defaultAvatar = "/images/navbar-profile-pic.jpeg";

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await api.get(`/posts/${postId}`);
        setPost(response.data);
      } catch (error) {
        console.error('Error fetching post:', error);
      }
    };

    if (postId) {
      fetchPost();
    }
  }, [postId]);

  const handlePostUpdate = (updatedPost) => {
    setPost(updatedPost);
  };

  if (!post) {
    return <Box sx={{ p: 3 }}>Loading...</Box>;
  }

  return (
    <Stack
      direction="column"
      sx={{
        bgcolor: "#ffffff",
        borderRadius: "24px",
        px: "20px",
        py: "16px",
        maxWidth: "800px",
        margin: "auto",
        mt: 2
      }}
    >
      <ProfileAndCommentComponent
        avatarSrc={post.user?.profileImage || defaultAvatar}
        primaryText={post.user ? `${post.user.firstName} ${post.user.lastName}` : "Unknown User"}
        secondaryText={new Date(post.createdAt).toLocaleString()}
        profile={true}
        menuOrImojiButton={{ src: "/icons/3dotsmenu.svg" }}
        postDescription={true}
      >
        <Box sx={{ fontSize: "14px", color: "#000000" }}>{post.text}</Box>
      </ProfileAndCommentComponent>

      <PostCommentAndLikesShareComponent post={post} onPostUpdate={handlePostUpdate} />
    </Stack>
  );
}

export default PostView; 